import React from "react";
import "../../css/article.scss";

const CopyText = ({ article, x }) => {
  return (
    <div className="copy-text" style={{ left: x(new Date(article.date)) }}>
      <p>{article.text}</p>
    </div>
  );
};

export default CopyText;
